import { useProPilotStore } from "PFApp/stores/propilot_store";
import { useTranslation } from "react-i18next";

import css from "./propilot_live_region.module.scss";

type ProPilotLiveRegionProps = {
  conversationId: string;
};

/**
 * Renders the latest agent message so screen readers announce exactly one
 * announcement per agent reply.
 */
export const ProPilotLiveRegion = ({ conversationId }: ProPilotLiveRegionProps) => {
  const { t } = useTranslation("translation");
  const latestAgentContent = useProPilotStore((state) => {
    const messages = state.conversations[conversationId]?.messages ?? [];
    const lastAgent = messages.findLast((message) => message.author === "agent");
    return lastAgent?.content;
  });

  const text = latestAgentContent?.text;
  const optionLabels = latestAgentContent?.options?.map((option) => option.label) ?? [];
  const optionsPrompt =
    optionLabels.length > 0
      ? t("propilot.liveRegion.optionsPrompt", { options: optionLabels.join(", ") })
      : "";
  const announcement = text && text.trim() !== "" ? text : optionsPrompt;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={css.liveRegion}
      data-qa-id="ProPilotLiveRegion"
    >
      {announcement}
    </div>
  );
};
